import React from 'react'
import PropTypes from 'prop-types'
import { DateTime } from 'luxon'
import { Link } from 'gatsby'

function Spacer() {
  return <span> | </span>
}

function Listing({ posts }) {
  return posts.map((post) => (
    <article
      key={post.id}
      className="et_pb_post post type-post status-publish format-standard hentry listing"
    >
      {post.feature_image ? (
        <Link to={`/${post.slug}`} title={post.title}>
          <img src={post.feature_image} alt={post.title} />
        </Link>
      ) : null}
      <h2>
        <Link to={`/${post.slug}`} title={post.title}>
          {post.title}
        </Link>
      </h2>
      <p className="post-meta">
        by{' '}
        <Link
          to={`/author/${post.primary_author.slug}`}
          title={post.primary_author.name}
          rel="author"
        >
          {post.primary_author.name}
        </Link>
        <Spacer />
        <time dateTime={post.published_at}>
          {DateTime.fromISO(post.published_at).toFormat('LLL d, y')}
        </time>
        <Spacer />
        {post.tags.map((postTag, i) => (
          <span key={postTag.slug}>
            <Link
              to={`/tag/${postTag.slug}`}
              title={postTag.name}
              rel="category tag"
            >
              {postTag.name}
            </Link>
            {i + 1 < post.tags.length ? ', ' : null}
          </span>
        ))}
        <Spacer />
      </p>
      {post.excerpt}
    </article>
  ))
}

Listing.propTypes = {
  posts: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      slug: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      published_at: PropTypes.string.isRequired,
      excerpt: PropTypes.string.isRequired,
      feature_image: PropTypes.string,
      primary_author: PropTypes.shape({
        slug: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
      }).isRequired,
      tags: PropTypes.arrayOf(
        PropTypes.shape({
          slug: PropTypes.string.isRequired,
          name: PropTypes.string.isRequired,
        }),
      ),
    }),
  ).isRequired,
}

export default Listing
